module.exports = __webpack_public_path__ + "a7d0d1b126e0a636136bf7b5c90b40e4.svg";